import React from "react";
import "./css/PhilosophyAndSustainabilityPage.css";
import FooterPagesBackground from "../assets/FooterPagesBackground.webp";
import liggandebakrund from "../assets/liggandebakgrund.svg";
import ToHomeBtn from "../components/Shared/ToHomepageBtn";
import FooterInsideSmallerPages from "./FooterInsideSmallerPages";

function PhilosophyAndSustainabilityPage() {

  return (
    <div className="filosofi-container">
      <div
        className="filosofi-background-image"
        style={{ backgroundImage: `url(${liggandebakrund})` }}
      ></div>
      <ToHomeBtn />
      <div className="filosofi-content-wrapper">
        <div className="filosofi-image-container">
          <img 
            src="https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?fm=jpg&q=80&w=1000" 
            alt="Filosofi och hållbarhet" 
            className="filosofi-image"
          />
        </div>
        <div className="filosofi-card">
          <h2>Filosofi Och Hållbarhet</h2>
          <p>This will be the philosophy content and sustainability</p>
        </div>
      </div>
      <FooterInsideSmallerPages />
    </div>
  );
}

export default PhilosophyAndSustainabilityPage;
